import React from 'react'

export default function GroqLoader() {

    return (
        <div className='groq_loader'>
        <div className='loader_txt'>
            Getting Details
        </div>
        <section className="dots-container">
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
            <div className="dot" />
        </section>
        </div>

    )
}
